export const getStyled = () => ({
  MainHeaderButtonsWrapper: {
    flex: 'none',
    marginLeft: 'auto',
  },
});
